import React from "react";
import "../../../assets/scss/BackOfficeStyles/Common.scss";
import Button from "@material-ui/core/Button";
import { DDVIpconfigLoc, MDR_LOCATIONS, MDRPatchMonitoringConfigurationLoc } from "../../../redux/constants/constants";

const ManagementFooter = ({
  cancelHandler,
  submitHandler,
  classname,
  loc,
  checkedValue,
}) => {
  const project = MDR_LOCATIONS.includes(window.location.pathname)
  ? "MDR"
  : "DDV";

  const MDRUser = window.location.pathname.includes("/mdr/userManagement/editUser/");

  const renderClassNames = () => {
    if (project === "MDR") {
      return classname ? `managementFooter ${classname} MDR` : "managementFooter MDR"
    } else {
      return classname ? `managementFooter ${classname}` : "managementFooter"
    }
  }
  return (
    <div
      className={renderClassNames()}
    >
      {loc === MDRPatchMonitoringConfigurationLoc ? (
        <Button
          // disabled={!checkedValue}
          variant="contained"
          className= {project === "MDR" ? "managementDone MDR" : "managementDone"}
          style={{ backgroundColor: project, marginLeft: "30%" }}
          onClick={submitHandler}
        >
          Done
        </Button>
      ) : (
        <>
          <Button
            variant="contained"
            className="managementCancel"
            onClick={cancelHandler}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className={
              loc === DDVIpconfigLoc ? "ddvManagementDone" : "managementDone"
            }
            style={{ backgroundColor: project === "MDR" || MDRUser ? "#47856d": "#2947FD" }}
            onClick={submitHandler}
          >
            Done
          </Button>
        </>
      )}
    </div>
  );
};

export default ManagementFooter;
